import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/gattomioNero.png'
import Accordion from './Accordion';

const PrivacePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Privacy & Policy'} pagesub={'Privacy'} />
            <section className="pf-terms-section section-padding ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                <div className="pf-terms-text">
                                    <h2>Informativa sulla Privacy e Trattamento Dati</h2>

                                    <p><strong>Titolare del trattamento:</strong> DTM di Turchiarelli Danilo Francesco — P.IVA 04456570714<br />
                                    Via Contrada Posta Cisterna, Snc — Castelluccio dei Sauri (FG) 71025<br />
                                    Email: dtmacchine@gmail.com — Tel. +39 348 722 6077</p>

                                    <p>
                                        La presente informativa spiega come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali
                                        quando acquisti i prodotti presenti nel nostro shop o utilizzi i servizi connessi,
                                        nel rispetto del Regolamento UE 2016/679 (GDPR).
                                    </p>

                                    <h3>1. Dati raccolti</h3>
                                    <p>
                                        Durante la navigazione e l'acquisto raccogliamo i seguenti dati:<br />
                                        <strong>Dati anagrafici e di contatto:</strong> nome, cognome, indirizzo email, numero di telefono.<br />
                                        <strong>Dati di spedizione:</strong> indirizzo di consegna e eventuali note per il corriere.<br />
                                        <strong>Dati di pagamento:</strong> gestiti esclusivamente tramite gateway sicuri e cifrati; il titolare non ha accesso ai dati della carta.<br />
                                        <strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser e pagine visitate, raccolti in forma anonima a fini statistici.
                                    </p>

                                    <h3>2. Finalità del trattamento</h3>
                                    <p>
                                        I dati sono trattati esclusivamente per:<br />
                                        Elaborare e gestire gli ordini di acquisto.<br />
                                        Comunicare aggiornamenti sullo stato della spedizione.<br />
                                        Rispondere a richieste di assistenza o informazioni.<br />
                                        Adempiere agli obblighi fiscali e contabili previsti dalla legge.<br />
                                        I tuoi dati non vengono mai ceduti a terzi per scopi pubblicitari o commerciali.
                                    </p>

                                    <h3>3. Conservazione e sicurezza</h3>
                                    <p>
                                        I dati sono conservati per il tempo strettamente necessario all'evasione dell'ordine e agli obblighi di legge (massimo 10 anni per la documentazione fiscale).<br />
                                        Utilizziamo protocolli di sicurezza adeguati per proteggere le informazioni da accessi non autorizzati.
                                    </p>

                                    <h3>4. I tuoi diritti (GDPR)</h3>
                                    <p>
                                        Ai sensi del Regolamento Europeo hai il diritto di: accedere ai tuoi dati, richiederne la rettifica o la cancellazione, opporti al trattamento, richiedere la portabilità.<br />
                                        Per esercitare questi diritti scrivi a <strong>dtmacchine@gmail.com</strong>.
                                    </p>
                                </div>
                                <div className="pf-faq-section" style={{marginTop: '50px'}}>
                                    <h4>Domande frequenti</h4>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <Accordion/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacePage;